<template>
	<div v-if="activities" class="py-8">
		<Timeline :value="allActivities" class="-ml-[100%]">
			<template #content="slotProps">
				<HistoryTimelineCard :item="slotProps.item" :index="slotProps.index"/>
			</template>
		</Timeline>
	</div>
</template>

<script>
import { mapStores } from "pinia";
import HistoryTimelineCard from "@/Components/HistoryTimelineCard.vue";
import {useDeviceRevisionsStore} from "@/stores/deviceRevisions.js";

export default {
	name: "DeviceRevisionHistoryView",
	components: {HistoryTimelineCard},
	data() {
		return {
			activities: undefined,
		}
	},
	computed: {
		...mapStores(useDeviceRevisionsStore),
		allActivities() {
			return [
				...this.activities,
			].sort((a, b) => Date.parse(b.created_at) - Date.parse(a.created_at));
		},
	},
	methods: {
		async refreshDeviceRevision() {
			return this.deviceRevisionsStore.showDeviceRevision(this.$route.params.revision, {
				fields: {device_revisions: 'id'},
				include: 'activities.causer',
			});
		},
	},
	watch: {
		'$route.params.revision': {
			async handler(newValue, oldValue) {
				if (newValue) {
					if (this.$route.params.revision === 'NEW') {
						this.activities = [];
					} else {
						const response = (await this.refreshDeviceRevision());
						this.activities = response.activities;
					}
				} else {
					this.activities = undefined;
				}
			},
			immediate: true,
		}
	},
}
</script>
